import { makeRequest } from "src/api/request";

export const getAvailableMembershipPackageList = async (params: API.Packages.List.Request = {}) => (
  await makeRequest.get<API.Packages.List.Response>("/subscriptions/available-packages/", {
    params: {
      ...params,
      ordering: "price,name",
      type: "membership",
    },
  })
);

export const getAvailableServicePackageList = async (params: API.Packages.List.Request = {}) => (
  await makeRequest.get<API.Packages.List.Response>("/subscriptions/available-packages/", {
    params: {
      ...params,
      ordering: "order",
      type: "service",
    },
  })
);

export const getAvailableCreditPackageList = async (params: API.Packages.List.Request = {}) => (
  await makeRequest.get<API.Packages.List.Response>("/subscriptions/available-packages/", {
    params: {
      ...params,
      ordering: "order",
      type: "credit",
    },
  })
);

export const getAvailableMembershipPackageDetail = async (id: API.Packages.PackageData["id"]) => (
  await makeRequest.get<API.Packages.Detail.Response>(`/subscriptions/available-packages/${id}/`)
);

export const createMembershipWithPackage = async (
  id: API.Packages.PackageData["id"],
  data: API.Packages.Purchase.Request,
) => (
  await makeRequest.post<API.Packages.Detail.Response>(`/subscriptions/packages/${id}/purchase/`, data)
);

export const getPackageOrderDetail = async (id: API.Packages.OrderData["id"]) => (
  await makeRequest.get<API.Packages.Order.Response>(`/subscriptions/orders/${id}/`)
);

export const createOrderPurchase = async (
  id: API.Packages.OrderData["id"],
  data: API.Packages.PurchaseOrder.Request,
) => (
  await makeRequest.post<API.Packages.PurchaseOrder.Response>(`/subscriptions/orders/${id}/purchase/`, data)
);

export const createOrderInstallment = async (
  id: API.Packages.OrderData["id"],
) => (
  await makeRequest.post<API.Packages.Installment.Response>(`/subscriptions/orders/${id}/installment/`)
);

export const createPackageOrder = async (id: API.Packages.PackageData["id"], data: API.Packages.Order.Request = {}) => (
  await makeRequest.post<API.Packages.Order.Response>(`/subscriptions/packages/${id}/order/`, data)
);

export const updatePackageOrder = async (
  id: API.Packages.PackageData["id"],
  data: Partial<API.Packages.UpdateOrder.Request>,
) => (
  await makeRequest.patch<API.Packages.Order.Response>(`/subscriptions/orders/${id}/`, data)
);

export const updatePackageOrderDiscount = async (
  id: API.Packages.PackageData["id"],
  data: API.Packages.OrderDiscount.Request,
) => (
  await makeRequest.post<API.Packages.OrderDiscount.Response>(`/subscriptions/orders/${id}/set-discount/`, data)
);
